import React from 'react'
import * as h from '../../helpers/helpers';
import * as rf from '../../data/reportFunctions';
import { lu } from '../../data/reportData';
import { H1, H2, SIG_B, TAB, TX_B, TXC, TXC_B, TXR, TXR_B, TXR_I, TXR_II } from "../../styles/urar-styles";

export function SIGNATURE() {
	let sigs = rf.GetSignatories();
	//console.log("sigs:", sigs);

	return (
		<>
			<H1 title="Signature" />
			{
				sigs.map((s, si) => {
					return (<SIGNER key={si} signer={s} />)
				})
			}
		</>
	)
}

export function SIGNER({signer}) {
	//console.log("signer:", signer);

	return (
		<>
			<div className='col2 mt-3'>
				<div>
					<TX_B title={signer.role} />
					<SIG_B name={signer.name} date={signer.date} />
				</div>
				<div>
					{ signer.license &&
					<>
						<TXR_B title="Level" value={signer.license.level} />
						<TXR_B title="ID" value={signer.license.id} />
						<TXR_B title="State" value={signer.license.state} />
						<TXR_B title="Expires" value={signer.license.date} />
					</>
					}
				</div>
			</div>
		</>
	)
}

